/*
 *  Copyright © Microsoft Corporation. All rights reserved.
 */

import { useReactiveVar } from '@apollo/client';
import { errorToString } from '@msteams/services-utilities-error';
import { tacRequestSettingsVar } from '../../apollo/reactiveVariables/TacRequestSettingsVariables';
import { LogCategory } from '../../logger';
import { RequestSettings, TacSettingsClient } from '../../service/gen';
import { getAppHost } from '../../utilities/TeamsUtils';

const getTacRequestSettingsRepr = (settings: RequestSettings | null): string =>
    settings ? `[RequestSettings keys=[${Object.keys(settings).join(', ')}]]` : '[RequestSettings null]';

export const initializeTacRequestSettingsAsync = async (): Promise<void> => {
    const logger = getAppHost().getLogger();

    let tacRequestSettings: RequestSettings;
    const startTime = performance.now();
    try {
        tacRequestSettings = await new TacSettingsClient().getTacRequestSettings();
        logger.logTraceInfo(
            LogCategory.TacRequestSettings,
            `Succeded to retrieve ${getTacRequestSettingsRepr(tacRequestSettings)}, elapsed ${
                performance.now() - startTime
            }`
        );
    } catch (e) {
        logger.logTraceError(
            LogCategory.TacRequestSettings,
            `Failed to initialize TacRequestSettings with error ${errorToString(e)}, elapsed ${
                performance.now() - startTime
            }`
        );
    }
    tacRequestSettings = tacRequestSettings ?? {};
    tacRequestSettingsVar(tacRequestSettings);
};

export const useTacRequestSettings = (): RequestSettings => useReactiveVar(tacRequestSettingsVar);
